module.exports = __webpack_public_path__ + "img/nolan-diff-files.807b1532.svg";